export const ZoomInIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clip-path="url(#a)">
      <path
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3 10a7 7 0 1 0 14 0 7 7 0 0 0-14 0Zm4 0h6m-2.995-2.995v6M21 21l-6-6"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ZoomOutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clip-path="url(#a)">
      <path
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3 10a7 7 0 1 0 14 0 7 7 0 0 0-14 0Zm4 0h6m8 11-6-6"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ResetZoomIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clip-path="url(#a)">
      <path
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M18 10h-4V6m6-2-6 6m-8 4h4v4m0-4-6 6"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
